import { Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { StyledFeatureLabel } from "../../styled/labels";

const FeatureLabel = ({ labelText, icon, onClick, tooltipText }) => {
  const [vibrar, setVibrar] = useState(false);
  const timeoutID = useRef();

  useEffect(() => {
    handleHover();
    return () => {
      clearTimeout(timeoutID.current);
    };
  }, []);

  const handleHover = () => {
    setVibrar(true);

    timeoutID.current = setTimeout(() => {
      setVibrar(false);
    }, 500);
  };

  return (
    <StyledFeatureLabel.LabelContainer>
      <StyledFeatureLabel.LabelText>{labelText}</StyledFeatureLabel.LabelText>
      <Tooltip title={tooltipText} arrow={true} onMouseEnter={handleHover}>
        {icon && <StyledFeatureLabel.Icon vibrar={vibrar} onClick={onClick}>{icon}</StyledFeatureLabel.Icon>}
      </Tooltip>
    </StyledFeatureLabel.LabelContainer>
  );
};

export default FeatureLabel;
